import React from 'react';
import Logo from '../assets/images/logo.png';

function MobileLogoComponent(props) {
  const { className, src = Logo } = props;
  return <img alt="logo" className={className} src={src} />;
}
export default MobileLogoComponent;
